module.exports = __webpack_public_path__ + "static/media/Cinch-Chace-Animated.0f0a84d2.mp4";